import ProximaBackground from './ProximaBackground';

export { ProximaBackground };

export default ProximaBackground;
